const buttons = document.querySelectorAll('.btn--secondary');
buttons.forEach((btn) => {
  btn.addEventListener('mouseenter', () => {
    btn.classList.remove('animate'); // Reset animation
    void btn.offsetWidth; // Force reflow to restart animation
    btn.classList.add('animate'); // Trigger animation
  });
  btn.addEventListener('mouseleave', () => {
    btn.classList.remove('animate'); // Reset
    void btn.offsetWidth; // Reflow again
    btn.classList.add('animate'); // Re-trigger animation
  });
});
